import ControlFactory from '@/Factories/ControlFactory';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import ControlFactoryTuple from '@/Factories/ControlFactoryTuple';

export default abstract class AsyncControlFactory extends ControlFactory implements IAsyncElementProvider, IAsyncTupleProvider<ControlFactoryTuple> {
    public getControl(): JQuery<HTMLElement> {
        throw new Error(`'getControl' is not supported in '${ this.constructor?.name ?? 'AsyncControlFactory' }'`);
    }

    abstract getElementAsync(): Promise<JQuery>;

    public async getTupleAsync(): Promise<ControlFactoryTuple> {
        if (this.tuple)
            return this.tuple;

        const $control = await this.getElementAsync();
        const $label = this.getLabel();
        this.tuple = new ControlFactoryTuple(this, $control, $label);
        return this.tuple;
    }
}